import { render, staticRenderFns } from "./BuyThirdGoods.vue?vue&type=template&id=14b67a75&scoped=true&"
import script from "./BuyThirdGoods.vue?vue&type=script&lang=js&"
export * from "./BuyThirdGoods.vue?vue&type=script&lang=js&"
import style0 from "./BuyThirdGoods.vue?vue&type=style&index=0&id=14b67a75&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b67a75",
  null
  
)

export default component.exports